import { render } from "./CompaniesLanding.vue?vue&type=template&id=5da8dc79"
import script from "./CompaniesLanding.vue?vue&type=script&lang=js"
export * from "./CompaniesLanding.vue?vue&type=script&lang=js"

import "./CompaniesLanding.vue?vue&type=style&index=0&id=5da8dc79&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__